import React, { ReactElement } from "react";
import { makeStyles } from "@material-ui/core";
import clsx from "clsx";

type MetricWrapperProps = {
  width?: "25%" | "33%" | "50%" | "66%" | "75%" | "100%";
  children: React.ReactNode;
};

const useStyles = makeStyles((theme) => ({
  metricWrapper: {
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    flex: "0 0 auto",
    [theme.breakpoints.down("sm")]: {
      width: "100% !important",
      maxWidth: "100% !important",
    },
  },
  width25: {
    width: "calc(25% - 18px)",
    maxWidth: "calc(25% - 18px)",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "100%",
    },
  },
  width33: {
    width: "calc(33.333% - 16px)",
    maxWidth: "calc(33.333% - 16px)",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "100%",
    },
  },
  width50: {
    width: "calc(50% - 12px)",
    maxWidth: "calc(50% - 12px)",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "100%",
    },
  },
  width66: {
    width: "calc(66.666% - 8px)",
    maxWidth: "calc(66.666% - 8px)",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "100%",
    },
  },
  width75: {
    width: "calc(75% - 6px)",
    maxWidth: "calc(75% - 6px)",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "100%",
    },
  },
  width100: {
    width: "100%",
    maxWidth: "100%",
  },
}));

const getWidthClass = ({
  width,
  classes,
}: {
  width?: "25%" | "33%" | "50%" | "66%" | "75%" | "100%";
  classes: ReturnType<typeof useStyles>;
}): string => {
  switch (width) {
    case "25%":
      return classes.width25;
    case "33%":
      return classes.width33;
    case "50%":
      return classes.width50;
    case "66%":
      return classes.width66;
    case "75%":
      return classes.width75;
    case "100%":
      return classes.width100;
    default:
      return "";
  }
};

const MetricWrapper = ({
  width,
  children,
}: MetricWrapperProps): ReactElement => {
  const classes = useStyles();

  if (!width) {
    return <>{children}</>;
  }

  return (
    <div
      className={clsx(classes.metricWrapper, getWidthClass({ width, classes }))}
    >
      {children}
    </div>
  );
};

export default MetricWrapper;
